<template>
  <div class="meRunningTime" ref="meRunningTime">
    <div class="meBox">
      <div
        class="meList"
        :style="{ left: -(nowListIndex * (baseItemWidth + 10)) + 'px' }"
        v-if="meList"
      >
        <div
          class="meItem"
          :style="{ width: baseItemWidth + 'px' }"
          v-for="(item, i) in meList"
          :key="i"
        >
          <div>{{ item.typeName }}</div>
          <div><img :src="imgUrlList[item.typeName]" alt="" /></div>
          <div class="textBase">
            总
            <count-too
              :value="countNum(item.count)"
              class="color1 number"
            ></count-too>
            台
          </div>
          <div class="textBase">
            月
            <count-too
              :value="countNum(item.runTime)"
              class="color2 number"
            ></count-too>
            h
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countToo from "@/components/vueCountTo";
export default {
  components: { countToo },
  props: ["matrix", "x", "y"],
  data() {
    return {
      computedName: '治理设备运行时长组件',
      customerId: this.$store.state.customerId,
      meList: [],
      imgUrlList: {
        静电除尘: require("./img/jindian.png"),
        布袋除尘器: require("./img/budai.png"),
        雾炮: require("./img/wupao.png"),
        天雾: require("./img/tianwu.png"),
        脱硫脱硝: require("./img/tuoliu.png"),
        纳膜设备: require("./img/namo.png"),
        干雾: require("./img/ganwu.png"),
        高压细水雾: require("./img/gaoya.png"),
      },
      nowListIndex: 0,
      baseItemWidth: 104,
    };
  },
  computed: {
    countNum() {
      return (num) => Number(num);
    },
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.meRunningTime).outerWidth();
    let h = $(that.$refs.meRunningTime).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.getListData();
    // this.test();
  },
  unmounted() {
    this.clearTimer(this.getlistTimer, false);
    this.clearTimer(this.listTimer);
  },
  methods: {
    // 每小时获取列表
    async getListData() {
      this.clearTimer(this.getlistTimer, false);
      let getMERunningTime = CONFIG.requestName + this.$apiOpt.getMERunningTime;
      let res = await this.$apiUtils.get(getMERunningTime, {
        customerId: this.customerId,
      });
      if (res) {
        this.meList = JSON.parse(JSON.stringify(res));
        // this.meList.push({
        //   typeName: "纳膜",
        //   count: 28,
        //   runTime: 3240.0,
        // });
        this.listCarousel();
      }
      this.getlistTimer = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 30);
    },
    // 列表轮播
    listCarousel() {
      this.clearTimer(this.listTimer);
      if (this.meList.length > 5) {
        this.listTimer = setInterval(() => {
          if (this.nowListIndex + 5 >= this.meList.length) {
            this.nowListIndex = 0;
          } else {
            this.nowListIndex++;
          }
        }, 1000 * 30);
      }
    },
    // 清除定时器
    clearTimer(timer, isInterval = true) {
      if (timer) {
        isInterval ? clearInterval(timer) : clearTimeout(timer);
        timer = null;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped="scoped">
.meRunningTime {
  height: 250px;
  width: 600px;
  .meBox {
    width: 560px;
    height: 182px;
    margin-top: 35px;
    overflow: hidden;
    position: relative;
    .meList {
      display: flex;
      position: absolute;
      transition: all 1.5s;
      > :not(:last-child) {
        margin-right: 10px;
      }
      .meItem {
        height: 182px;
        background: url("./img/itemBg.png") no-repeat 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        div:nth-child(1) {
          line-height: 30px;
          height: 30px;
        }
        div:nth-child(2) {
          height: 74px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
          }
        }
        .textBase {
          height: 39px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 6px;
          > .color1 {
            color: rgba(244, 196, 143, 1);
          }
          > .color2 {
            color: rgba(71, 255, 221, 1);
          }
        }
      }
    }
  }
}
</style>
